import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { useCurrency } from '../context/CurrencyContext';
import { useTheme } from '../context/ThemeContext';

const Ticker = () => {
  const { prices, selectedCurrency, currencyConfig } = useCurrency();
  const { theme } = useTheme();
  const config = currencyConfig[selectedCurrency];

  const formatPrice = (price) => {
    if (!price) return '-';
    if (price >= 10000) {
      return price.toLocaleString(config.locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }
    return price.toLocaleString(config.locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  return (
    <div 
      className="border-b overflow-hidden transition-colors duration-300"
      style={{ backgroundColor: theme.bgSecondary, borderColor: theme.border }}
    >
      <div className="ticker-wrapper py-2">
        <div className="ticker-content flex gap-8 animate-ticker">
          {[...prices, ...prices, ...prices].map((item, index) => {
            const isUp = item.ask > item.prevAsk;
            const isDown = item.ask < item.prevAsk;
            const change = item.prevAsk ? ((item.ask - item.prevAsk) / item.prevAsk * 100).toFixed(2) : '0.00';

            return (
              <div key={`${item.id}-${index}`} className="flex items-center gap-3 whitespace-nowrap">
                <span className="text-[#d4af37] font-semibold text-xs">{item.alias}</span>
                <span className="font-mono text-sm" style={{ color: theme.text }}>
                  {config.symbol}{formatPrice(item.ask)}
                </span>
                <span className={`flex items-center gap-1 text-xs font-medium ${
                  isUp ? 'text-green-400' : isDown ? 'text-red-400' : ''
                }`} style={!isUp && !isDown ? { color: theme.textSecondary } : {}}>
                  {isUp ? <TrendingUp className="w-3 h-3" /> : isDown ? <TrendingDown className="w-3 h-3" /> : null}
                  {change > 0 ? '+' : ''}{change}%
                </span>
                <span style={{ color: theme.textMuted }}>|</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Ticker;
